import { finalRouteApi } from "./CommonApiUrl"


const movieOrderDefaultURL = {
    listApi: `${finalRouteApi}/Movies-HomePage-Order/index`,
    orderApi: `${finalRouteApi}/Movies-HomePage-Order/ordering`,
    editApi: `${finalRouteApi}/Movies-HomePage-Order/edit`,
    updateApi: `${finalRouteApi}/Movies-HomePage-Order/update`,
    editRouteLink: `${finalRouteApi}/Audio_URL`,
    enableSettingURL: `${finalRouteApi}/Web-Movies-HomePage/index`,
    updateSettingURL: `${finalRouteApi}/Web-Movies-HomePage/update`,
    enableSettingMobileURL: `${finalRouteApi}/Movies-Mobile-HomePage/index`,
}

export { movieOrderDefaultURL }